// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"102b2f7f","977":"5a4c08f0"}[chunkId] + ".chunk.js";
};